module.exports = __webpack_public_path__ + "media/images/minus-circle-8d16f0e0fab7433898a8965585c4c503.svg";